import { defineStyleConfig } from '@chakra-ui/styled-system';

const ChipInput = defineStyleConfig({
  baseStyle: {
    ':has(:focus-visible)': { boxShadow: 'outline' },
    appearance: 'none',
    background: 'neutral.100',
    border: '1px solid',
    borderColor: 'neutral.90',
    borderRadius: '4',
    boxShadow: 'inner',
    outline: 0,
    padding: '0.6875rem',
    transition: '200ms',
    width: '100%',
    _readOnly: {
      background: 'background.disabled',
    },
  },
});

export default ChipInput;
